import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faAngleDoubleDown, faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons";
import { Button } from 'react-bootstrap';
import classnames from 'classnames';
import moment from 'moment';
import 'moment-timezone';
import TextMessage from './TextMessage'

import './AlertDetail.scss'

interface AlertDetailProps {
  alert: any,
  isShowFullContent: boolean
}

const AlertDetail: React.FC<AlertDetailProps> = ({ alert, isShowFullContent }) => {
  const [isExpand, setIsExpand] = useState(false);

  const clientTimeZone = moment.tz.guess();
  const dateFormat = (timestamp: number) =>
    moment.tz(timestamp, clientTimeZone).format('YYYY-MM-DD HH:mm:ss z');

  return (
    <div className="alert-detail">
      {
        alert.priority && <span className="alert-detail-priority pr-2"><FontAwesomeIcon icon={faExclamationTriangle} /></span>
      }
      <span className="alert-detail-title">{alert.title}</span>
      <div className="container">
        <div className="row alert-detail-time my-1 justify-content-between">
          <div className="col-auto px-0">
            {dateFormat(alert.createDate)}
          </div>
          <div className="col-auto px-0">
            {alert.notificationId}
          </div>
        </div>
      </div>
      <div className={classnames('alert-detail-content', { 'limit-height': !isShowFullContent && !isExpand })}>
        <TextMessage text={alert.body} />
      </div>
      {
        !isShowFullContent &&
        <div className="alert-detail-footer text-center mt-1">
          <Button
            variant="link"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsExpand(!isExpand)
            }}>
            <i className={isExpand ? 'fold-icon' : 'unfold-icon'}></i>
          </Button>
        </div>
      }
    </div>
  )
}

export default AlertDetail;